/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ApplicationAliases {
  COMPOSED_CHART_FRAGMENT = 'composed-chart-fragment',
  COMPOSED_CHART_ROUTE = 'composed-chart-route',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DASHBOARD_FRAGMENT = 'dashboard-fragment',
  DASHBOARD_ROUTE = 'dashboard-route',
  FRAGMENT_CUSTOMER_USER_ITEM = 'fragment-customer-user-item',
  FRAGMENT_CUSTOMER_USER_LIST = 'fragment-customer-user-list',
  FRAGMENT_KPIOPENED = 'fragment-kpiopened',
  FRAGMENT_MESSAGE = 'fragment-message',
  FRAGMENT_OS_GENERATED = 'fragment-os-generated',
  FRAGMENT_OS_OPENED_GRAPHICS = 'fragment-os-opened-graphics',
  FRAGMENT_OSOPENEDGRAPHICS = 'fragment-osopenedgraphics',
  FRAGMENT_RESOLUTION_TIME = 'fragment-resolution-time',
  FRAGMENT_SLA_FILES = 'fragment-sla-files',
  FRAGMENT_SLA_OS_LIST = 'fragment-sla-os-list',
  FRAGMENT_VERSION_ITEM = 'fragment-version-item',
  FRAGMENT_VERSION_LIST = 'fragment-version-list',
  KPIOPENED = 'kpiopened',
  MAIN_APPLICATION = 'main-application',
  MAIN_APPLICATION_BAR = 'main-application-bar',
  MAIN_FOOTER = 'main-footer',
  MESSAGE = 'message',
  MESSAGE_ITEM = 'message-item',
  MESSAGE_ITEM_FRAGMENT = 'message-item-fragment',
  OS_OPENED_GRAPHICS = 'os-opened-graphics',
  OSOPENEDGRAPHICS = 'osopenedgraphics',
  PRODUCT_MANUAL_FRAGMENT = 'product-manual-fragment',
  PRODUCT_MANUAL_ROUTE = 'product-manual-route',
  ROUTE_CUSTOMER_USER_ITEM = 'route-customer-user-item',
  ROUTE_CUSTOMER_USER_LIST = 'route-customer-user-list',
  ROUTE_OS_GENERATED = 'route-os-generated',
  ROUTE_RESOLUTION_TIME = 'route-resolution-time',
  ROUTE_SLA_FILES = 'route-sla-files',
  ROUTE_SLA_OS_LIST = 'route-sla-os-list',
  ROUTE_VERSION_ITEM = 'route-version-item',
  ROUTE_VERSION_LIST = 'route-version-list',
  SETTINGS_FRAGMENT = 'settings-fragment',
  SETTINGS_ROUTE = 'settings-route',
  USER_ITEM_FRAGMENT = 'user-item-fragment',
  USER_ITEM_ROUTE = 'user-item-route',
  USER_PROFILE_BAR = 'user-profile-bar',
}
export { ApplicationAliases };
